import { useState, type FormEvent } from 'react'
import { Link } from 'react-router-dom'
import { tellSoc } from '../../lib/api'
import { btnBrass, routeError } from './SocShell'
import { cn } from '../../lib/utils'

// "Tell your SOC something": one note, POST /soc/tell-us. The thank-you is
// the route's own acknowledgement sentence.

export function TellSocForm({
  placeholder,
  compact = false,
}: {
  placeholder: string
  compact?: boolean
}) {
  const [note, setNote] = useState('')
  const [busy, setBusy] = useState(false)
  const [ack, setAck] = useState<string | null>(null)
  const [error, setError] = useState<string | null>(null)

  async function onSubmit(e: FormEvent) {
    e.preventDefault()
    const value = note.trim()
    if (!value || busy) return
    setBusy(true)
    setError(null)
    try {
      const out = await tellSoc(value)
      setAck(out.acknowledgement)
      setNote('')
    } catch (err) {
      setError(routeError(err, 'We could not send your note. Please try again.'))
    } finally {
      setBusy(false)
    }
  }

  return (
    <form onSubmit={onSubmit} className="flex flex-[1_1_360px] flex-col gap-2.5">
      <label htmlFor="soc-note" className="text-[13px] uppercase tracking-[.12em] text-brass-light">
        Your note
      </label>
      <textarea
        id="soc-note"
        rows={compact ? 2 : 3}
        value={note}
        maxLength={4000}
        onChange={(e) => setNote(e.target.value)}
        placeholder={placeholder}
        className="resize-y rounded-md border border-[#3a4652] bg-[#12222e] p-3 font-sans text-[15px] text-cream"
      />
      <div className="flex flex-wrap items-center gap-2.5">
        <button type="submit" className={cn(btnBrass, compact && 'flex-1')} disabled={busy || !note.trim()}>
          Send to your SOC
        </button>
        {!compact && (
          <Link to="/client/concierge" className="text-[13px] text-[#d9cdb8] hover:text-white">
            Or talk to your team
          </Link>
        )}
      </div>
      {ack && (
        <p className="m-0 text-[15px] font-bold text-brass-light" role="status">
          {ack}
        </p>
      )}
      {error && (
        <p className="m-0 text-[15px] text-[#f3b0a8]" role="alert">
          {error}
        </p>
      )}
    </form>
  )
}
